import React from 'react';
import { interDuce } from './data.scoure';
import { Link } from "react-router-dom";

export default class About extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
    }
    render() {
        const data = interDuce.data;
        return (
            <center class="text-center ml-6 mr-6" >
                <div class="mr-6 ml-6 grid grid-cols-4 xl:pl-32 xl:pr-32 md:grid-cols-2 sm:grid-cols-1">
                    {data.map(data => {
                        const { image, title, description } = data;
                        return (
                            <div class="pt-16 pl-16 pr-16 xl:pr-4 xl:pl-4 sm:pl-0 sm:pr-0" key={title}>
                                <img
                                    src={"https://organic-naturetea.com/shenglongTest/asset/" + image}
                                    alt={title}
                                    class="flex mr-auto ml-auto w-20"
                                />
                                <p class="text-3xl">{title}</p>
                                {description}
                                <br />
                            </div>
                        )
                    })}
                </div>
                <div class="pt-20 grid grid-cols-4 gap-4 ml-64 mr-64 md:ml-0 md:mr-0 md:grid-cols-2 sm:grid-cols-2 sm:gap-3 sm:ml-0 sm:mr-0" id="context">
                    <div class="relative">
                        <a href="https://line.me/R/ti/p/Ndtea3GYpS">
                            <div class="qrcodediv qrlinebot h-56 w-56 absolute sm:right-0 md:right-0 sm:h-40 sm:w-40"></div>
                        </a>
                    </div>
                    <div class="">
                        <a href="https://organic-naturetea.com/">
                            <div class="qrcodediv qrweb h-56 w-56 sm:h-40 sm:w-40" />
                        </a>
                    </div>
                    <center class="relative">
                        <Link class="w-full" to="https://www.facebook.com/%E8%9F%AC%E5%90%83%E8%8C%B6%E3%81%AE%E5%A4%A9%E7%84%B6%E8%8C%B6%E9%A3%B2-%E5%90%B3%E8%88%88%E7%B8%BD%E5%BA%97-209515929122406">
                            <div class="qrcodediv qrfacebook h-56 w-56 absolute sm:right-0 md:right-0 sm:h-40 sm:w-40" />
                        </Link>
                    </center>
                    <div class="qrcodediv h-56 w-56 sm:h-40 sm:w-40" />
                </div>
                <br />
            </center >
        )
        // else
        //     return (
        //         <center class="text-center ml-56 mr-56" >
        //             <div class="wrapper p-12">
        //                 {data.map(data => {
        //                     const { image, title, description } = data;
        //                     return (
        //                         <div class="pb-6">
        //                             <img
        //                                 src={"https://organic-naturetea.com/shenglongTest/asset/" + image}
        //                                 alt={title}
        //                                 class="flex mr-auto ml-auto w-20"
        //                             />
        //                             <p class="text-2xl">{title}</p>
        //                             <br />
        //                             {description}
        //                         </div>
        //                     )
        //                 })}
        //             </div>
        //             <div class="wrapper" id="context">
        //                 <a href="https://line.me/R/ti/p/Ndtea3GYpS">
        //                     <div class="qrcodediv qrlinebot h-40 w-40"></div>
        //                 </a>
        //                 <a href="https://organic-naturetea.com/">
        //                     <div class="qrcodediv qrweb h-40 w-40" />
        //                 </a>
        //                 <a href="https://www.facebook.com/%E8%9F%AC%E5%90%83%E8%8C%B6%E3%81%AE%E5%A4%A9%E7%84%B6%E8%8C%B6%E9%A3%B2-%E5%90%B3%E8%88%88%E7%B8%BD%E5%BA%97-209515929122406">
        //                     <div class="qrcodediv qrfacebook h-40 w-40" />
        //                 </a>
        //                 <div class="qrcodediv h-40 w-40" />
        //             </div>
        //             <br />
        //         </center >
        //     )
    }
}